import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFlightRoundCityResultFilterData, getFlightRoundCityTwoTypeVender } from '../../services/flight/flightServices';

// Async Thunk for fetching filtered round trip flight list
export const fetchRoundCityFlightFilterList = createAsyncThunk(
    'flight/fetchRoundCityFlightFilterList',
    async ({ reqBody }, { rejectWithValue }) => {
        try {
            // const response = await getFlightRoundCityResultFilterData(reqBody);
            const response = await getFlightRoundCityTwoTypeVender(reqBody);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Slice for managing round trip flight state
const flightRoundCityFlightSlice = createSlice({
    name: 'flightRoundCity',
    initialState: {
        roundCityFlightFilterData: null,
        filterLoading: false,
        filterError: null,
    },
    reducers: {
        clearFlightData: (state) => {
            state.roundCityFlightFilterData = null;
        },
    },
    extraReducers: (builder) => {
        // Handling fetchRoundCityFlightFilterList
        builder
            .addCase(fetchRoundCityFlightFilterList.pending, (state) => {
                state.filterLoading = true;
                state.filterError = null;
            })
            .addCase(fetchRoundCityFlightFilterList.fulfilled, (state, action) => {
                state.roundCityFlightFilterData = action.payload;
                state.filterLoading = false;
            })
            .addCase(fetchRoundCityFlightFilterList.rejected, (state, action) => {
                state.filterLoading = false;
                state.filterError = action.payload;
            });
    },
});

export const { clearFlightData } = flightRoundCityFlightSlice.actions;

export default flightRoundCityFlightSlice.reducer;
